'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  & .overlay-content {\n    align-items: center;\n    background: ', ';\n    color: ', ';\n    cursor: pointer;\n    display: flex;\n    font-family: sans-serif;\n    height: 0;\n    hyphens: auto;\n    justify-content: center;\n    left: 0;\n    opacity: 0;\n    overflow: visible;\n    padding: calc(50%);\n    position: absolute;\n    text-align: center;\n    top: 0;\n    transition: opacity 300ms ease;\n    width: 0;\n  }\n\n  &:hover .overlay-content,\n  &.hover-test .overlay-content {\n    opacity: 0.85;\n  }\n'], ['\n  & .overlay-content {\n    align-items: center;\n    background: ', ';\n    color: ', ';\n    cursor: pointer;\n    display: flex;\n    font-family: sans-serif;\n    height: 0;\n    hyphens: auto;\n    justify-content: center;\n    left: 0;\n    opacity: 0;\n    overflow: visible;\n    padding: calc(50%);\n    position: absolute;\n    text-align: center;\n    top: 0;\n    transition: opacity 300ms ease;\n    width: 0;\n  }\n\n  &:hover .overlay-content,\n  &.hover-test .overlay-content {\n    opacity: 0.85;\n  }\n']);

var _colors = require('HubStyleTokens/colors');

var _AvatarWrapper = require('./AvatarWrapper');

var _AvatarWrapper2 = _interopRequireDefault(_AvatarWrapper);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

exports.default = (0, _styledComponents2.default)(_AvatarWrapper2.default).withConfig({
  displayName: 'AvatarWrapperOverlay'
})(_templateObject, _colors.SLINKY, _colors.OLAF);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ui-addon-avatars/static-2.493/js/UIAvatarDisplay/baseStyledComponents/AvatarWrapperOverlay.js
// module id = 999
// module chunks = 2 3